(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["example-report-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    // Shopify protects sign-up forms with an invisible "are you human" check
    // that runs when the form is sent the normal way. So the form is sent the
    // normal way: the page reloads at the box and shows "Check your inbox".
    // Script only catches a mistyped email first, and remembers the address so
    // the confirmation can name it.
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const KEY = 'noorns-xr-email';
    document.addEventListener('submit', (e) => {
      const form = e.target.closest && e.target.closest('form.xr__form');
      if (!form) return;
      const input = form.querySelector('input[type=email]');
      const err = form.querySelector('.xr__err');
      const email = (input.value || '').trim();
      if (!EMAIL.test(email)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        input.classList.add('is-error');
        if (err) err.hidden = false;
        input.focus();
        return;
      }
      input.value = email;
      // "Just the report" ticked: put the full tag list, including
      // example-report-only, in the hidden field too, so the posted value is
      // the same whichever copy Shopify reads.
      const only = form.querySelector('[data-xr-only]');
      const tags = form.querySelector('input[type=hidden][name="contact[tags]"]');
      if (only && only.checked && tags) tags.value = only.value;
      try { sessionStorage.setItem(KEY, email); } catch (_) {}
      const btn = form.querySelector('.xr__btn');
      if (btn) btn.textContent = 'Sending...';
    }, true);

    document.querySelectorAll('[data-xr-email]').forEach((el) => {
      let email = '';
      try { email = sessionStorage.getItem(KEY) || ''; sessionStorage.removeItem(KEY); } catch (_) {}
      if (email) { el.textContent = email; el.closest('[data-xr-named]')?.removeAttribute('hidden'); el.closest('.xr__done')?.querySelector('[data-xr-plain]')?.setAttribute('hidden', ''); }
    });
    document.querySelectorAll('.xr__input').forEach((input) => input.addEventListener('input', () => {
      input.classList.remove('is-error');
      const err = input.form && input.form.querySelector('.xr__err');
      if (err) err.hidden = true;
    }));

    // Product pages: the box sits right under the key points box at the top
    // of the description (Cam, 2026-10-06: not next to the buy buttons, where
    // it could pull buyers aside). It stays hidden until it is placed, so the
    // page doesn't jump. The key points box's own "Get a free example report"
    // link is hidden, since the box is right below it.
    const box = document.querySelector('.xr--product[data-xr]');
    if (box) {
      const key = [...document.querySelectorAll('.rte > div[style]')].find((el) => /#f6f2fc/i.test(el.getAttribute('style') || ''));
      if (key) {
        key.after(box);
        key.querySelectorAll('a[href*="__section_tUjXVr"]').forEach((a) => { (a.closest('div') !== key ? a.closest('div') : a).hidden = true; });
      }
      box.classList.add('is-placed');
      document.querySelectorAll('a[href*="__section_tUjXVr"]').forEach((a) => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          box.querySelector('input[type=email]')?.focus({ preventScroll: true });
        });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
